const state = {
    all_lessond:[]
};

const mutations = {
    all_lessond: function (state, all_lessond) {
        state.all_lessond = all_lessond;
    },
};

const actions = {};

const getters = {
    RESOURCE_NO_VIDEO(){
        return state.all_lessond
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
}